import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions';
import {toJS} from "../hocs/toJs";
import Stores from './stores';
import {formValueSelector} from "redux-form/immutable";

const selector = formValueSelector('sortStoresForm');

class StoresHOC extends Component {

  componentDidMount(){
    this.props.getStores({});
  }

  render(){
    return (
      <Stores
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stores: state.stores.get('stores'),
    fetchingStores: state.stores.get('fetching'),
    patchingCollection: state.stores.get('patchingCollection'),
    patchingCollectionMessage: state.stores.get('patchingCollectionMessage'),
    mobileViewSortBy: selector(state, 'sortBy'),
    mobileViewSortOrder: selector(state, 'sortOrder'),
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getStores: (payload) => {
      dispatch(actions.getStores(payload))
    },
    updateStoresCollection: (payload) => {
      dispatch(actions.updateStoresCollection(payload))
    },
    changeStoresState: (payload) => {
      dispatch(actions.changeStoresState(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(StoresHOC));



// WEBPACK FOOTER //
// ./src/components/stores/storesHOC.js